import axios from 'axios';

const availableLangs = {
  'en-GB': 'en-GB',
  'it-IT': 'it-IT',
  'de-DE': 'de-DE',
};

const getLang = () => {
  const siteCoreLang = (window.smartFaq && window.smartFaq.isoCode) || 'en-GB';
  return siteCoreLang ? availableLangs[siteCoreLang] || 'en-GB' : 'en-GB';
};

const qnaRequest = (params, options = {}) => {
  const lang = getLang();
  const apiBaseUrl = process.env.REACT_APP_QNA_API_URL || '';
  const url = `${apiBaseUrl}/qna/`;

  return axios
    .post(
      url,
      {
        ...params,
        lang,
      },
      {
        ...options,
      },
    )
    .catch((error) => {
      window.newrelic.noticeError(error);
      return null;
    });
};

const getAnswer = async (text) => {
  const params = {
    mode: 'answer',
    question: text,
  };
  return qnaRequest(params, {
    transformResponse: [
      (data) => {
        try {
          const parsed = JSON.parse(data);
          return parsed.answers[0];
        } catch (e) {
          // http error will be propagated to axios.catch
          return data;
        }
      },
    ],
  });
};

const getSuggestions = async (text) => {
  const params = {
    mode: 'suggestions',
    question: text,
  };
  return qnaRequest(params, {
    transformResponse: [
      (data) => {
        const parsed = JSON.parse(data);
        const suggestions = parsed.answers
          .filter((a) => a.confidenceScore > 0)
          .map((a) => ({
            value: a.questions[0],
          }));
        return {
          suggestions,
        };
      },
    ],
  });
};

const defaultSuggestions = {
  'en-GB': [
    { value: 'How do I purchase S&L ETPs?' },
    {
      value: 'Will a 3x leveraged ETP always deliver exactly 3x the return of the underlying?',
    },
    { value: 'Can I lose money with S&L ETPs?' },
  ],
  'it-IT': [
    { value: 'Come posso investire in ETP S&L' },
    {
      value: 'Un ETP con tripla leva (3x) consegnerà sempre esattamente tre volte il rendimento del sottostante?',
    },
    { value: 'Rischio di perdere denaro con gli ETP S&L?' },
  ],
  'de-DE': [
    { value: 'Wie investiere ich in S&L ETPs?' },
    {
      value: 'Erzielt ein dreifach gehebeltes ETP immer genau die dreifache Rendite des Basiswerts?',
    },
    { value: 'Kann ich mit S&L ETPs Geld verlieren?' },
  ],
};

const getDefaultSuggestions = () => {
  const lang = getLang();
  return defaultSuggestions[lang];
};

const getContactUrl = () => {
  const siteCoreLang = (window.smartFaq && window.smartFaq.isoCode) || 'en-GB';
  return `${process.env.REACT_APP_CONTACT_US_URL}/${siteCoreLang.toLowerCase()}/contact-us`;
};

const API = {
  getAnswer,
  getSuggestions,
  getDefaultSuggestions,
  getContactUrl,
};

export default API;
